<template>
  <div>
    <!-- <iframe id="aaa" src="http://www.baidu.com"></iframe> -->
    <!-- <el-input v-model="c"></el-input> -->
    <div class="pay_success" v-if="canPay == '1' && states[0] == 1">
      <img class="iv_logo_title" src="@/assets/images/space/iv_logo_title.png" alt="" v-if="states[0] == 1" />
      <div class="v_line_success" v-if="states[0] == 1"></div>
      <div class="v_text_middle" v-if="states[0] == 1">
        <div class="v_text_middle_gay">产品名称：</div>
        <div class="v_text_middle_black">{{ successName }}</div>
      </div>
      <div class="v_text_middle" style="margin-top: 2rem" v-if="states[0] == 1">
        <div class="v_text_middle_gay">支付金额：</div>
        <div class="v_text_middle_orange">￥</div>
        <div class="v_text_middle_orange">{{ create.pay }}</div>
      </div>
      <div class="v_text_middle" style="margin-top: 2rem" v-if="states[0] == 1">
        <div class="v_text_middle_gay">有效期限：</div>
        <div class="v_text_middle_black">一年</div>
      </div>

      <!-- <div
        class="v_text_middle_renew"
        v-if="states[0] != 1"
        style="margin-top: 5rem"
      >
        <div class="v_text_middle_gay_renew" style="letter-spacing: 0.45rem">
          产品名称：
        </div>
        <div class="v_text_middle_black_renew">{{ successName }}</div>
        <div class="v_text_middle_gay_another">{{ create.addYear }}</div>
      </div> -->
      <!-- <div
        class="v_text_middle_renew"
        v-if="states[0] != 1"
        style="margin-top: 2rem"
      >
        <div class="v_text_middle_gay_renew">纪念堂封面：</div>
        <img
          class="iv_space"
          :src="create.img"
          alt=""
          v-if="create.img != '—'"
        />
        <div
          class="v_text_middle_black_renew"
          style="margin-left: 0.2rem"
          v-if="create.img == '—'"
        >
          {{ create.img }}
        </div>
      </div> -->
      <!-- <div
        class="v_text_middle_renew"
        v-if="states[0] != 1"
        style="margin-top: 2rem"
      >
        <div class="v_text_middle_gay_renew">纪念堂名称：</div>
        <div class="v_text_middle_black_renew" style="margin-left: 0.2rem">
          {{ create.name }}
        </div>
      </div> -->
      <!-- <div
        class="v_text_middle_renew"
        v-if="states[0] != 1"
        style="margin-top: 2rem"
      >
        <div class="v_text_middle_gay_renew">纪念堂编号：</div>
        <div class="v_text_middle_black_number">{{ create.code }}</div>
      </div> -->
      <!-- <div
        class="v_text_middle_renew"
        v-if="
          states[0] != 1 && create.overdueDays != 0 && create.overdueDays != '—'
        "
        style="margin-top: 2rem"
      >
        <div class="v_text_middle_gay_renew" style="letter-spacing: 0.45rem">
          逾期天数：
        </div>
        <div class="v_text_middle_black_renew">{{ create.overdueDays }}天</div>
        <img
          class="iv_space_icon"
          src="@/assets/images/space/iv_question.png"
          alt=""
          @click="toShowOverdue"
        />
      </div> -->
      <!-- <div
        class="v_text_middle_renew"
        style="margin-top: 2rem"
        v-if="
          states[0] != 1 && create.overdueDays != 0 && create.overdueDays != '—'
        "
      >
        <div class="v_text_middle_gay_renew" style="letter-spacing: 0.45rem">
          逾期金额：
        </div>
        <div class="v_text_middle_orange_renew" style="margin-left: -0.5rem">
          ￥
        </div>
        <div class="v_text_middle_orange_renew">{{ create.overdueFee }}</div>
      </div> -->
      <!-- <div
        class="v_text_middle_renew"
        style="margin-top: 2rem"
        v-if="states[0] != 1"
      >
        <div class="v_text_middle_gay_renew" style="letter-spacing: 0.45rem">
          支付金额：
        </div>
        <div class="v_text_middle_orange_renew" style="margin-left: -0.5rem" v-if="create.pay != '—'">
          ￥
        </div>
        <div class="v_text_middle_orange_renew" v-if="create.pay != '—'">{{ create.pay }}</div>
        <div class="v_text_middle_orange_renew_black" v-if="create.pay == '—'">{{ create.pay }}</div>
      </div> -->
      <!-- <div
        class="v_text_middle_renew"
        v-if="states[0] != 1"
        style="margin-top: 2rem"
      >
        <div class="v_text_middle_gay_renew" style="letter-spacing: 0.45rem">
          有效期至：
        </div>
        <div class="v_text_middle_black_renew">{{ create.endDay }}</div>
      </div> -->

      <div class="pay_success_item_a"></div>
      <div class="v_text_middle_green" v-if="isOk">支付成功</div>
      <div class="v_to_go" @click="toPayCreate()" v-if="!isOk && isNoEvery">
        支付
      </div>
      <div class="v_to_go" @click="toGo()" v-if="isOk">前往小程序</div>
      <div class="v_argee">
        <img class="iv_argee" v-if="!isClick && !isHaveChocie" src="@/assets/images/space/iv_click_no.png" alt=""
          @click="toAgree()" />
        <img class="iv_argee" v-if="isClick && !isHaveChocie" src="@/assets/images/space/iv_click_yes.png" alt=""
          @click="toAgree()" />
        <div v-if="!isHaveChocie" class="v_argee_black">已阅读并同意</div>
        <div v-if="!isHaveChocie" class="v_argee_orange" @click="toRead()">
          《服务条款》
        </div>
        <div v-if="!isHaveChocie" class="v_argee_orange" @click="toReadA()">
          《隐私政策》
        </div>
      </div>
      <div class="pay_success_item_b"></div>
    </div>

    <div class="pay_success_renew" v-if="canPay == '1' && states[0] != 1">
      <div class="renew_top">
        <img class="renew_top_space" :src="create.img" alt="" />
        <div class="renew_top_right">
          <div class="renew_top_right_name">{{ create.name }}</div>
          <div class="v_text_middle_renew" style="margin-top:0.5rem;">
            <div class="renew_top_right_text">纪念堂编号：</div>
            <div class="renew_top_right_text" style="margin-left: 0.2rem">{{ create.code }}</div>
          </div>
          <div class="v_text_middle_renew">
            <!-- style="letter-spacing: 0.45rem" -->
            <div class="renew_top_right_text">
              有效期至：
            </div>
            <div class="renew_top_right_text" style="margin-left: 0.2rem">{{ create.oldDay }}</div>
          </div>
        </div>
      </div>
      <div class="v_line"></div>
      <div class="v_text_middle_renew" style="margin-top: 1.5rem" v-if="
        states[0] != 1 && create.overdueDays != 0 && create.overdueDays != '—'
      ">
        <div class="renew_day_text" style="margin-left:1.8rem">逾期</div>
        <div class="renew_day_text_red"> {{ create.overdueDays }} </div>
        <div class="renew_day_text">天</div>
        <img class="iv_space_icon" style="margin-left:1rem;" src="@/assets/images/space/iv_question.png" alt=""
          @click="toShowOverdue" />
      </div>
      <div class="v_text_middle_renew_another" style="margin-top: 1.5rem" v-if="
        states[0] != 1 && create.overdueDays != 0 && create.overdueDays != '—'
      ">
        <div class="renew_day_text_little" style="margin-left:1.8rem;">
          <span class="renew_day_text_number">0.15 </span>元/天
        </div>
        <div class="renew_day_text_number_right">{{ create.overdueFee }}元</div>
      </div>

      <div class="v_line_background"></div>
      <div class="v_year_renew_text">年度充值</div>
      <div class="v_text_middle_renew_another" style="margin-top: 1.5rem; margin-bottom: 1.5rem;">
        <div class="renew_day_text_little" style="margin-left:1.8rem"><span class="renew_day_text_number">{{
        create.price
        }}
          </span>元/年</div>
        <div class="renew_day_text_end">有效期至：{{ create.endDay }}</div>
      </div>
      <div class="v_renew_middle"></div>

      <div class="v_renew_pay_all_background" v-if="isShowDetail">
        <div class="v_particulars_bottom">
          <div class="v_text_middle_renew_another"
            style="height:3.1rem;line-height:3.1rem;margin-top:2.5rem;margin-bottom:0.5rem;">
            <div class="v_particulars_title">支付明细</div>
            <div class="v_particulars_cancle" @click.stop="toShowDetail">取消</div>
          </div>
          <div class="v_text_middle_renew_another" style="line-height:6.5rem;height:6.5rem;">
            <div class="v_text_middle_renew_black"><span class="v_text_middle_renew_gay">1</span>纪念堂1年年费</div>
            <div class="v_text_middle_renew_orange"><span>¥</span>{{ create.price }}</div>
          </div>
          <div class="v_line_renew" v-if="
            states[0] != 1 && create.overdueDays != 0 && create.overdueDays != '—'
          "></div>
          <div class="v_text_middle_renew_another" style="line-height:6.5rem;height:6.5rem;" v-if="
            states[0] != 1 && create.overdueDays != 0 && create.overdueDays != '—'
          ">
            <div class="v_text_middle_renew_black"><span class="v_text_middle_renew_gay">2</span>纪念堂逾期费</div>
            <div class="v_text_middle_renew_orange"><span>¥</span>{{ create.overdueFee }}</div>
          </div>
        </div>
      </div>

      <div class="v_renew_pay" v-if="!isOk">
        <div class="v_renew_pay_left">
          <div class="v_renew_pay_total">合计：</div>
          <div class="v_renew_pay_logo">¥</div>
          <div class="v_renew_pay_number">{{ create.pay }}</div>
          <div class="v_renew_pay_all" @click.stop="toShowDetail"
            v-if="create.overdueDays != 0 && create.overdueDays != '—'">明细</div>
          <img class="iv_renew_pay_top" src="@/assets/images/space/iv_show_top.png" alt=""
            v-if="!isShowDetail && create.overdueDays != 0 && create.overdueDays != '—'" @click.stop="toShowDetail" />
          <img class="iv_renew_pay_top" src="@/assets/images/space/iv_show_bottom.png" alt=""
            v-if="isShowDetail && create.overdueDays != 0 && create.overdueDays != '—'" @click.stop="toShowDetail" />
        </div>
        <div class="v_renew_pay_button" @click="toPayCreate()" v-if="!isOk && isNoEvery">支付</div>
      </div>

      <div class="v_renew_pay_success" v-if="isOk">
        <div class="v_text_middle_green">支付成功</div>
        <div class="v_to_go_renew" @click="toGo()">前往小程序</div>
      </div>

    </div>

    <div class="pay_error" v-if="canPay == '2'">
      <img class="iv_none" src="@/assets/images/space/iv_none.png" alt="">
    </div>

    <el-dialog custom-class="wang_dialog" width="320px" :visible.sync="overdueDialog" :show-close="false" center
      :close-on-click-modal="false">
      <div class="wang_dialog_text">
        纪念堂逾期后平台将不会删除相关资料，需对保存的资料收取相应的存储费用，0.15元/天
      </div>
      <div class="v_dialog_line"></div>
      <div class="v_dialog_button" @click="overdueClose">确定</div>
    </el-dialog>

    <el-dialog custom-class="wang_dialog" width="320px" :visible.sync="pastDueDialog" :show-close="false" center
      :close-on-click-modal="false">
      <div class="wang_dialog_text">
        {{ pastDueTitle }}
      </div>
      <div class="v_dialog_line"></div>
      <div class="v_dialog_button" @click="removeClose">关闭</div>
    </el-dialog>

    <el-dialog custom-class="wang_dialog" width="320px" :visible.sync="removeDialog" :show-close="false" center
      :close-on-click-modal="false">
      <div class="wang_dialog_text">{{ title }}</div>
      <div class="v_dialog_line"></div>
      <div class="v_dialog_button" @click="removeClose">关闭</div>
    </el-dialog>

    <el-dialog custom-class="wang_dialog_a" title="服务条款" width="32rem" :visible.sync="readDialog" :show-close="false"
      center :close-on-click-modal="false">
      <div class="wang_dialog_text_a">
        <!-- <br v-if="textItem.span"> -->
        <div class="content_area">
          <div v-for="(item, index) in pageData" :key="index" class="text" :style="{ 'text-align': item.align }">
            <span v-for="(textItem, indexItem) in item.text" :key="indexItem" :class="textItem.bold ? 'bold_text' : ''"
            :style="{ 'white-space': textItem.space }">
              {{ textItem.content }}
            </span>
          </div>
        </div>
      </div>
      <div class="v_dialog_line"></div>
      <div class="v_dialog_button" @click="readClose">关闭</div>
    </el-dialog>

    <el-dialog custom-class="wang_dialog_a" title="隐私政策" width="32rem" :visible.sync="readADialog" :show-close="false"
      center :close-on-click-modal="false">
      <div class="wang_dialog_text_a">
        <div class="content_area">
          <div v-for="(item, index) in pageDataA" :key="index" class="text" :style="{ 'text-align': item.align }">
            <span v-for="(textItem, indexItem) in item.text" :key="indexItem" :class="textItem.bold ? 'bold_text' : ''"
            :style="{ 'white-space': textItem.space }">
              {{ textItem.content }}
            </span>
          </div>
        </div>
      </div>
      <div class="v_dialog_line"></div>
      <div class="v_dialog_button" @click="readAClose">关闭</div>
    </el-dialog>
  </div>
</template>

<script>
import { updataLink } from "@/utils/utils";
import contents from "../pay/content.js";
export default {
  data() {
    return {
      url: "",

      codeM: "",
      states: [],
      isOk: false,
      closeTime: "",
      create: {
        price: "",
        pay: "",
        overdueDays: "",
        overduePrice: "",
        overdueFee: "",
        originalPrice: "",
        dmCloseTime: "",
        img: "",
        name: "",
        code: "",
        endDay: "",
        addYear: "",
        oldDay: '',
      },
      token: "",
      overdueDialog: false,
      successName: "",
      isClick: false,
      pastDueDialog: false,
      removeDialog: false,
      canPay: '1',
      title: "",
      readDialog: false,
      readADialog: false,
      isHaveChocie: true,
      pastDueTitle: "",
      isNoEvery: true,
      pageData: [],
      pageDataA: [],
      isFirst: true,
      isCanClick: false,
      isShowDetail: false,
      //c:'',
      isLogin: false
    };
  },
  created() {
    document.title = "";
    let link = window.location.href;
    let links = link.split("code=");

    this.getServiceTerms()
    this.getPrivacyPolicy()

    if (links.length > 1) {
      this.codeM = links[1].split("&state=")[0];
      let linkState = links[1].split("&state=")[1].split("#/pay")[0];
      this.states = linkState.split("_");
      this.isLogin = true;
      this.wxcodeH5();
    } else {
      //无code
      this.isLogin = false;
      let linkState = links[0].split("&state=")[1].split("#/pay")[0];
      this.states = linkState.split("_");
      this.findProductById('', false)
    }

    window.onload = function () {
      document.addEventListener("touchstart", function (event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      });
      document.addEventListener("gesturestart", function (event) {
        event.preventDefault();
      });
    };


  },
  methods: {
    getServiceTerms() {
      let testRequest = new Request(
        this.url + "/mobile/bygUser/getPrivacyPolicy",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json;charset=UTF-8;",
            "apiVersion":2022101255
          },
          // body: JSON.stringify({
          //   data: {},
          // }),
        }
      );
      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          console.log(res);
          res.data =res.data.replaceAll('\r\n','')
          res.data =res.data.replaceAll('\\\\r\\\\n','\\r\\n')
          res.data =res.data.replaceAll('`','"')
          let b = JSON.parse(res.data)
          this.pageDataA = b.content
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    getPrivacyPolicy() {
      let testRequest = new Request(
        this.url + "/mobile/bygUser/getServiceTerms",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json;charset=UTF-8;",
            "apiVersion":2022101255
          },
          // body: JSON.stringify({
          //   data: {},
          // }),
        }
      );
      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          console.log(res);
          res.data =res.data.replaceAll('\r\n','')
          res.data =res.data.replaceAll('\\\\r\\\\n','\\r\\n')
          res.data =res.data.replaceAll('`','"')
          let b = JSON.parse(res.data)
          this.pageData = b.content
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    wxcodeH5() {
      let testRequest = new Request(
        this.url + "/mobile/login/wxcodeH5Register",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json;charset=UTF-8;",
          },
          body: JSON.stringify({
            data: {
              code: this.codeM,
            },
          }),
        }
      );
      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          console.log(res);
          //this.c = JSON.stringify(res)
          if (res.status == 1000) {
            if (res.data.data.privacyState == 1) {
              //同意协议
              this.isHaveChocie = true;
            } else {
              //不同意协议
              if (this.states[0] != 1) {
                //续费
                this.isHaveChocie = true;
              } else {
                this.isHaveChocie = false;
                this.$message({
                  showClose: false,
                  message: "请先阅读并同意协议",
                  center: true,
                  offset: document.documentElement.clientHeight - 250,
                  customClass: "message_class",
                });
              }
            }
            this.token = res.data.token;
            if (res.data.data.privacyState == 1) {
              //校验
              this.findProductById(res.data.token, true);
            } else {
              if (this.states[0] != 1) {
                //续费
                this.findProductById(res.data.token, true);
              } else {
                //新建
                this.findProductById(res.data.token, false);
              }
            }
          } else if (res.status == 1051) {
            //刷新code换不到openId
            this.isCanClick = true;
            this.toShowError();
          } else {
            this.isCanClick = true;
            this.toShowError();
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    //获取商品详情
    findProductById(token, isPay) {
      let data = {};
      data = {
        id: this.states[0],
        timeStamp: this.states[2],
        uuid: this.states[3],
      };
      //takerToken: token,
      let headers = {
        "Content-Type": "application/json;charset=UTF-8;",
      };
      //续费
      if (this.states[0] != 1) {
        data.dmId = this.states[1];
        headers.dmId = this.states[1];
        headers.dmUserValidate = 0
      }
      let testRequest = new Request(
        this.url + "/mobile/bygOrder/findProductById",
        {
          method: "POST",
          credentials: "include",
          headers: headers,
          body: JSON.stringify({
            data: data,
          }),
        }
      );
      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          //this.c = JSON.stringify(res)
          this.isCanClick = true;
          if (res.status == 1000) {

            //时间戳是否有效：1是、0否
            if (res.data.timeStampState != 1) {
              this.canPay = '2'
              let name = this.states[0] == 1 ? "新建" : "续费";
              this.title = name + "二维码失效，请联系客服";
              this.removeDialog = true;
              return;
            }

            //是否已支付：1是，0否
            if (res.data.payState == 1) {
              this.canPay = '2'
              let name = this.states[0] == 1 ? "新建" : "续费";
              this.title = name + "二维码失效，请联系客服";
              this.removeDialog = true;
              return;
            }

            if (this.states[0] == 1) {
              this.canPay = '1'
              //新建
              this.successName = "新建纪念堂";
              this.create.price = res.data.price.toFixed(2);
              this.create.pay = res.data.price.toFixed(2);
            } else if (this.states[0] != 1) {
              this.canPay = '1'
              //续费
              this.successName = "纪念堂续费";
              if (this.isFirst) {
                this.isFirst = false;
                this.closeTime = res.data.dmCloseTime;
              }
              this.create.price = res.data.price.toFixed(2);
              //this.create.overdueDays = res.data.overdueDays;
              this.create.overdueDays = 0;
              this.create.overduePrice = res.data.overduePrice.toFixed(2);
              this.create.overdueFee = res.data.overdueFee.toFixed(2);
              this.create.originalPrice = res.data.originalPrice;
              this.create.dmCloseTime = res.data.dmCloseTime;
              // + res.data.overdueFee
              this.create.pay = (res.data.price).toFixed(
                2
              );
              this.create.img = res.data.dmCoverUrl;
              this.create.name = res.data.dmName;
              //res.data.addYear
              this.create.addYear = '（1年）';
              var arr = res.data.dmCode.split("");
              var arrs = [];
              var str = "";
              while (arr.length > 0) {
                var arrThis = arr.splice(0, 4);
                var strThis = arrThis.join("");
                arrs.push(strThis);
              }
              str = arrs.join(" ");
              this.create.code = str;

              if (res.data.dmForeverState != 1) {
                var dateTo = new Date(res.data.dmCloseTime);
                dateTo.setDate(dateTo.getDate() + res.data.overdueDays);
                dateTo.setFullYear(dateTo.getFullYear() + res.data.addYear);
                let year = dateTo.getFullYear();
                let month = dateTo.getMonth() + 1;
                let day = dateTo.getDate();
                let strYear = year.toString();
                let strMonth = month > 9 ? `${month}` : `0${month}`;
                let strDay = day > 9 ? `${day}` : `0${day}`;
                this.create.oldDay = res.data.dmCloseTime.substring(0, 4) + '/' +
                  res.data.dmCloseTime.substring(5, 7) + '/' +
                  res.data.dmCloseTime.substring(8, 10)
                this.create.endDay = `${strYear}/${strMonth}/${strDay}`;
              }
            }

            //纪念堂是否永久有效：1是，0否
            if (res.data.dmForeverState == 1) {
              this.create.oldDay = "永久";
              this.create.endDay = "永久";
              this.isNoEvery = false;
              this.title = "纪念堂已是永久纪念堂，无需续费";
              this.removeDialog = true;
              return;
            }

            //纪念堂是否自动续期：1是，0否
            if (res.data.autoRenewState == 1) {
              this.title = "纪念堂已开通连续包年，到期自动扣款暂无需续费";
              this.removeDialog = true;
              return;
            }

            //是否可以续费：1是、0否
            if (res.data.renewState == 0 && this.states[0] != 1) {
              this.title = "纪念堂不在续费期，请有效期小于1年内时进行续费";
              this.removeDialog = true;
              return;
            }

            if (isPay) {
              this.add(token);
            }
          } else {
            this.canPay = '2'
            this.successName = "—"
            this.create = {
              price: "—",
              pay: "—",
              overdueDays: "—",
              overduePrice: "—",
              overdueFee: "—",
              originalPrice: "—",
              dmCloseTime: "—",
              img: "—",
              name: "—",
              code: "—",
              endDay: "—",
              oldDay: "—",
              addYear: "",
            };
            if (res.status == 1072) {
              this.title = "您不是该纪念堂的管理员不可支付";
              this.removeDialog = true;
            } else if (res.status == 1070) {
              this.title = "此纪念堂已被冻结，请联系客服解冻";
              this.removeDialog = true;
            } else if (res.status == 1098) {
              this.title = "纪念堂已失效,请联系客服";
              this.removeDialog = true;
            } else {
              this.toShowError();
            }
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    //新建订单信息
    add(token) {
      let data = {};
      data = {
        productId: this.states[0],
        payType: 4,
        timeStamp: this.states[2],
        uuid: this.states[3],
      };
      let headers = {};
      headers = {
        "Content-Type": "application/json;charset=UTF-8;",
        takerToken: token,
      };
      //续费
      if (this.states[0] != 1) {
        data.dmId = this.states[1];
        data.closeTime = this.closeTime;
        headers.dmId = this.states[1];
      }
      let testRequest = new Request(this.url + "/mobile/bygOrder/add", {
        method: "POST",
        credentials: "include",
        headers: headers,
        body: JSON.stringify({
          data: data,
        }),
      });
      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          console.log(res);
          //this.c = JSON.stringify(res)
          if (res.status == 1000) {
            this.getWxPayOrder(res.message, token);
          } else if (res.status == 1084) {
            this.title = "已有管理员在支付状态，请稍后再试";
            this.removeDialog = true;
          } else if (res.status == 1085) {
            this.title = "已有管理员支付成功";
            this.removeDialog = true;
          } else if (res.status == 1098) {
            this.title = "纪念堂已失效，请联系客服";
            this.removeDialog = true;
          } else if (res.status == 1070) {
            this.title = "此纪念堂已被冻结，请联系客服解冻";
            this.removeDialog = true;
          } else if (res.status == 1072) {
            this.title = "您不是该纪念堂的管理员不可支付";
            this.removeDialog = true;
          } else if (res.status == 1106) {
            //this.title = "订单失效";
            let name = this.states[0] == 1 ? "新建" : "续费";
            this.title = name + "二维码失效，请联系客服";
            this.removeDialog = true;
          } else if (res.status == 1107) {
            let name = this.states[0] == 1 ? "新建" : "续费";
            this.title = name + "二维码失效，请联系客服";
            this.removeDialog = true;
          } else if (res.status == 1108) {
            this.title = "纪念堂不在续费期，请有效期小于1年内时进行续费";
            this.removeDialog = true;
          } else {
            this.toShowError();
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    //获取微信支付信息
    getWxPayOrder(id, token) {
      let testRequest = new Request(
        this.url + "/mobile/bygOrder/getWxPayOrder",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json;charset=UTF-8;",
            takerToken: token,
          },
          body: JSON.stringify({
            data: id,
          }),
        }
      );

      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          if (res.status == 1000) {
            this.onBridgeReady(res.data);
          } else {
            this.toShowError();
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    //微信付款
    onBridgeReady(res) {
      let that = this;
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: res.appId, //公众号ID，由商户传入
          timeStamp: res.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: res.nonceStr, //随机串
          package: res.packageStr,
          signType: res.signType, //微信签名方式：
          paySign: res.paySign, //微信签名
        },
        function (res) {
          console.log(res);
          that.isHaveChocie = true;
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            // 使用以上方式判断前端返回,微信团队郑重提示：
            //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            that.isOk = true;
            that.isShowDetail = false;
          } else {
            this.toShowError();
          }
        }
      );
    },

    //支付按钮
    toPayCreate() {
      if (!this.isCanClick) {
        return
      }
      if (this.isHaveChocie) {
        if (this.isLogin) {
          //登陆
          this.findProductById(this.token, true);
        } else {
          //没登录
          if (this.states[0] == 1) {
            //新建
            let testRequest = new Request(
              this.url + "/mobile/bygOrder/getPurchaseOauthUrlH5",
              {
                method: "POST",
                credentials: "include",
                headers: {
                  "Content-Type": "application/json;charset=UTF-8;",
                },
                body: JSON.stringify({
                  data: {
                    productId: this.states[0],
                    timeStamp: this.states[2],
                    uuid: this.states[3],
                  },
                }),
              }
            );

            fetch(testRequest)
              .then((response) => {
                return response.json();
              })
              .then((res) => {
                if (res.status == 1000) {

                  location.replace(res.data);
                  //this.$router.replace(res.data);
                  //location.replace(res.data)
                } else {
                  this.toShowError();
                }
              })
              .catch(function (err) {
                console.log(err);
              });
          } else {
            //续费
            let data = {};
            data = {
              productId: this.states[0],
              dmId: this.states[1],
              timeStamp: this.states[2],
              uuid: this.states[3],
            };
            let testRequest = new Request(
              this.url + "/mobile/bygOrder/getRenewOauthUrlH5",
              {
                method: "POST",
                credentials: "include",
                headers: {
                  "Content-Type": "application/json;charset=UTF-8;",
                },
                body: JSON.stringify({
                  data: data,
                }),
              }
            );

            fetch(testRequest)
              .then((response) => {
                return response.json();
              })
              .then((res) => {
                if (res.status == 1000) {
                  //this.$router.replace(res.data)
                  location.replace(res.data);
                } else {
                  this.toShowError();
                }
              })
              .catch(function (err) {
                console.log(err);
              });
          }
        }
      } else {
        if (!this.isClick) {
          this.$message({
            showClose: false,
            message: "请先阅读并同意协议",
            center: true,
            offset: document.documentElement.clientHeight - 250,
            customClass: "message_class",
          });
        } else {
          this.agreePrivacy();
        }
      }
    },

    toShowError() {
      // this.$message.error({
      //   showClose: false,
      //   message: "获取信息失败，请检查网络连接",
      //   center: true,
      //   offset: document.documentElement.clientHeight / 2,
      //   customClass: "message_class_red",
      // });
      this.canPay = '2';
      this.title = "访问错误，请重新扫码进入";
      this.removeDialog = true;
    },

    toGo() {
      //跳转小程序
      // if (updataLink() == "test/") {
      //   //测试
      //   location.href = "weixin://dl/business/?t=M6Bp0sxOb7l";
      // } else if (updataLink() == "train/") {
      //   //训练
      //   location.href = "weixin://dl/business/?t=tGnAOjThisr";
      // } else if (updataLink() == "product/") {
      //   //家书
      //   location.href = "weixin://dl/business/?t=xXK346A3pHh";
      // }

      let testRequest = new Request(
        this.url + "/common/wxGenerateScheme",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json;charset=UTF-8;",
          },
          body: JSON.stringify({
            data: {
              path: 'pages/index/index',
              env_version: 'release',
            },
          }),
        }
      );

      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          if (res.status == 1000) {
            location.href = res.data.openlink
          } else {

          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    //同意隐私条款
    agreePrivacy() {
      let testRequest = new Request(this.url + "/mobile/bygUser/agreePrivacy", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json;charset=UTF-8;",
          takerToken: this.token,
        },
        body: JSON.stringify({}),
      });

      fetch(testRequest)
        .then((response) => {
          return response.json();
        })
        .then((res) => {
          if (res.status == 1000) {
            this.findProductById(this.token, true);
          } else {
            this.toShowError();
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    //同意、拒绝协议
    toAgree() {
      this.isClick = !this.isClick;
    },

    toShowOverdue() {
      this.overdueDialog = true;
    },

    overdueClose() {
      this.overdueDialog = false;
    },

    removeClose() {
      this.title = "";
      this.pastDueDialog = false;
      this.removeDialog = false;
      setTimeout(function () {
        //这个可以关闭安卓系统的手机
        document.addEventListener(
          "WeixinJSBridgeReady",
          function () {
            WeixinJSBridge.call("closeWindow");
          },
          false
        );
        //这个可以关闭ios系统的手机
        WeixinJSBridge.call("closeWindow");
      });
    },

    toRead() {
      this.readDialog = true;
    },

    toReadA() {
      this.readADialog = true;
    },

    readClose() {
      this.readDialog = false;
    },

    readAClose() {
      this.readADialog = false;
    },

    toShowDetail() {
      if (this.isShowDetail) {
        this.isShowDetail = false;
      } else {
        this.isShowDetail = true;
      }
    }
  },
};
</script>

<style lang="stylus" scoped>

.pay_error {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  align-items: center;

  .iv_none {
    width:165px;
    height:165px;
    margin-top:103px;
  }
}

.pay_success_renew {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  .v_text_middle_green {
    font-size: 18px;
    font-weight: 500;
    color: #00D01A;
    margin-bottom: 15px;
  }

  .v_renew_pay_success {
    width: 100%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .v_to_go_renew {
    width: 220px;
    height: 50px;
    background: linear-gradient(90deg, #FF9B5D 0%, #FFBB00 100%);
    box-shadow: 0px 8px 24px 2px #FFDDC3;
    border-radius: 25px;
    line-height: 50px;
    font-size: 18px;
    font-weight: 400;
    text-align: center;
    color: #FFFFFF;
  }

  .renew_top {
    display: flex;
    flex-direction: row;
    // min-height: 110px;
    width:100%;
    align-items: center;
    margin-top:15px;
    margin-bottom:15px;
  }

  .renew_top_space {
    width: 60px;
    height: 80px;
    margin-left: 18px;
  }

  .renew_top_right {
    margin-left:20px;
  }

  .renew_top_right_name {
    font-size: 25px;
    font-weight: 500;
    color: #000000;
  }

  .renew_top_right_text {
    font-size: 13px;
    font-weight: 400;
    color: #949494;
  }

  .v_line {
    margin-left: 18px;
    margin-right: 18px;
    width: auto;
    height: 1px;
    background: #D5D5D5;
  }

  .v_line_renew {
    margin-left: 25px;
    margin-right: 27px;
    width: auto;
    height: 1px;
    background: #D5D5D5;
  }

  .renew_day_text {
    font-size: 18px;
    font-weight: 500;
    color: #000000;
  }

  .renew_day_text_red {
    font-size: 18px;
    font-weight: 500;
    color: #CB0000;
  }

  .renew_day_text_little{
    font-size: 15px;
    font-weight: 500;
    color: #000000;
  }

  .renew_day_text_number {
    font-size: 17px;
    font-weight: 500;
    color: #EE9400;
  }

  .renew_day_text_number_right {
    margin-right: 18px;
    font-size: 17px;
    font-weight: 500;
    color: #CB0000;
  }

  .v_line_background {
    margin-top:15px;
    width: 100%;
    height: 10px;
    background: #F7F8F9;
  }

  .v_year_renew_text {
    margin-top:15px;
    margin-left:18px;
    font-size: 18px;
    font-weight: 500;
    color: #000000;
  }

  .renew_day_text_end {
    margin-right: 18px;
    font-size: 15px;
    font-weight: 400;
    color: #949494;
  }

  .v_renew_middle {
    flex-grow: 2;
    background: #F7F8F9;
  }

  .v_renew_pay_all_background{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background:rgba(0, 0, 0, 0.7);
  }

  .v_particulars_bottom {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 89px;
    background:#ffffff;
    border-radius: 15px 15px 0px 0px;
  }

  .v_particulars_title {
    margin-left: 25px;
    font-size: 22px;
    font-weight: 500;
    color: #000000;
  }

  .v_particulars_cancle {
    margin-right: 25px;
    font-size: 17px;
    font-weight: 400;
    color: #F19100;
  }

  .v_renew_pay{
    display: flex;
    flex-direction: row;
    width: 100%;
    min-height: 88px;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background:#ffffff;
    align-items: center;
    justify-content: space-between;
    padding-bottom:10px;
    box-sizing: border-box;
    border-top: 1px solid #D5D5D5;

    .v_renew_pay_left {
      display: flex;
      flex-direction: row;
      align-items: center;
      line-height: 84px;
      height:84px;
    }

    .v_renew_pay_total {
      margin-left: 18px;
      font-size: 18px;
      font-weight: 400;
      color: #000000;
    }

    .v_renew_pay_logo {
      font-size: 18px;
      font-weight: 400;
      color: #ED9802;
    }

    .v_renew_pay_all {
      margin-left:19px;
      font-size: 18px;
      font-weight: 400;
      color: #EE9400;
      flex-shrink: 0;
    }

    .iv_renew_pay_top {
      width:14px;
      height:8px;
      padding-left:5px;
      padding-right:10px;
      padding-top:30px;
      padding-bottom:30px;
    }

    .v_renew_pay_number {
      font-size: 30px;
      font-weight: 500;
      color: #EE9400;
    }

    .v_renew_pay_button {
      width: 85px;
      height: 35px;
      line-height: 35px;
      background: linear-gradient(180deg, #FFBC29 0%, #EC9600 100%);
      border-radius: 20px;
      font-size: 17px;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;
      margin-right: 18px;
    }
  }
}

.v_text_middle_renew {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.v_text_middle_renew_another{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.v_text_middle_renew_gay{
  margin-left:25px;
  font-size: 16px;
  font-weight: 400;
  color: #949494;
  margin-right:15px;
}

.v_text_middle_renew_black {
  font-size: 16px;
  font-weight: 400;
  color: #000000;
}

.v_text_middle_renew_orange {
  font-size: 16px;
  font-weight: 400;
  color: #EE9400;
  margin-right:27px;
}

.iv_space_icon {
  margin-left: 5px;
  width: 20px;
  height: 20px;
}

.pay_success {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;

  .iv_space {
    margin-left: 5px;
    width: 75px;
    height: 100px;
    border-radius: 5px;
  }

  .iv_logo_title {
    margin-top: 25px;
    width: 166px;
    height: 108px;
  }

  .v_line_success {
    margin-top: 40px;
    margin-bottom: 40px;
    width: 200px;
    height: 1px;
    border-bottom: 1px dashed #4E3300;
  }

  .v_text_middle {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 200px;
  }

  .v_text_middle_gay {
    font-size: 20px;
    color: #949494;
    font-weight: 500;
  }

  .v_text_middle_gay_another {
    font-size: 15px;
    color: #949494;
    font-weight: 400;
  }

  .v_text_middle_gay_renew {
    font-size: 18px;
    color: #949494;
    font-weight: 400;
  }

  .v_text_middle_black {
    font-size: 20px;
    color: #000000;
    font-weight: 500;
    overflow: hidden; // 超出部分隐藏
    text-overflow: ellipsis; // 隐藏部分用...代替
    white-space: nowrap;
    max-width: 150px;
  }

  .v_text_middle_black_renew {
    font-size: 18px;
    color: #000000;
    font-weight: 500;
    overflow: hidden; // 超出部分隐藏
    text-overflow: ellipsis; // 隐藏部分用...代替
    white-space: nowrap;
    max-width: 150px;
  }

  .v_text_middle_black_number {
    margin-left: 2px;
    font-size: 17px;
    color: #000000;
    font-weight: 500;
  }

  .v_text_middle_orange {
    font-size: 20px;
    color: #F09200;
    font-weight: 600;
  }

  .v_text_middle_orange_renew {
    font-size: 18px;
    color: #F09200;
    font-weight: 600;
  }

  .v_text_middle_orange_renew_black {
    font-size: 18px;
    color: #000000;
    font-weight: 600;
  }

  .v_text_middle_green {
    font-size: 18px;
    font-weight: 500;
    color: #00D01A;
    margin-bottom: 15px;
  }

  .v_to_go {
    width: 220px;
    height: 50px;
    background: linear-gradient(90deg, #FF9B5D 0%, #FFBB00 100%);
    box-shadow: 0px 8px 24px 2px #FFDDC3;
    border-radius: 25px;
    line-height: 50px;
    font-size: 18px;
    font-weight: 400;
    text-align: center;
    color: #FFFFFF;
    margin-bottom: 20px;
  }

  .v_argee {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 300px;
    height: 40px;
    // margin-bottom: 30px;
  }

  .iv_argee {
    width: 16px;
    height: 16px;
    padding: 15px;
  }

  .v_argee_black {
    font-size: 13px;
    font-weight: 400;
    color: #000000;
    height: 40px;
    line-height: 40px;
  }

  .v_argee_orange {
    font-size: 13px;
    font-weight: 400;
    color: #F19200;
    height: 40px;
    line-height: 40px;
  }

  .pay_success_item_a {
    flex-grow: 10;
  }

  .pay_success_item_b {
    flex-grow: 1;
  }
}
</style>

<style>
.message_class {
  min-width: 190px !important;
  background-color: #000000 !important;
  border-color: #000000 !important;
  border-radius: 30px !important;
  padding: 0 !important;
  height: 40px !important;
  line-height: 40px !important;
}

.message_class_red {
  min-width: 270px !important;
  border-color: 0 !important;
  border: 0 !important;
  border-radius: 30px !important;
  padding: 0 !important;
  height: 40px !important;
  line-height: 40px !important;
}

.message_class .el-message__content {
  color: #ffffff !important;
}

.message_class .el-icon-info {
  color: #ffffff !important;
}

.wang_dialog {
  border-radius: 15px !important;
  margin-top: 30vh !important;
}

.wang_dialog .el-dialog__header {
  height: 0;
  line-height: 0;
  padding: 0;
  border-bottom: 0;
}

.wang_dialog .el-dialog__body {
  padding: 30px 0 0 0 !important;
}

.wang_dialog_a .el-dialog__body {
  padding: 20px 20px 0 20px !important;
}

.wang_dialog_a {
  border-radius: 15px !important;
  margin-top: 20vh !important;
}

.wang_dialog_text {
  font-size: 18px;
  font-weight: 500;
  color: #000000;
  line-height: 33px;
  text-align: center;
  padding-left: 20px;
  padding-right: 20px;
}

.wang_dialog_text_a {
  font-size: 14px;
  font-weight: 500;
  color: #3b3b3b;
  line-height: 16px;
  max-height: 250px;
  overflow-y: auto;
  overflow-x: hidden;
  white-space: pre-line;
  word-break: break-all;
  word-wrap: break-word;
}

.bold_text {
  font-weight: bold;
  color: #000000;
}

.v_dialog_line {
  margin-top: 17px;
  height: 1px;
  background: #d8d8d8;
}

.v_dialog_button {
  font-size: 20px;
  font-weight: 500;
  color: #ef9400;
  line-height: 70px;
  height: 70px;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/Pay/pay.vue